/**
 * 通用请求接口
 * @author Sky
 */
import { join } from 'lodash'
import request from '@/utils/request'

/**
 * getAllDepartment 查看公司全部部门（事业部）
 */
export function getAllDepartment (params) {
  return request({
    url: '/v1/base_data/all_department',
    method: 'get',
    params
  })
}
/**
 * getAllDepartment 查看公司权限部门（事业部）
 */
export function getPermissionDepartment (params) {
  return request({
    url: '/v1/base_data/get_permissionOrg',
    method: 'get',
    params
  })
}
/**
 * getAllDepartment 查看当前版本全部部门（事业部）
 */
export function getVersionDepartment (params) {
  return request({
    url: '/v1/base_data/all_department_by_version',
    method: 'get',
    params
  })
}

/**
 * getAreas 查看当前用户有权限的地区
 */
export function getAreas (params) {
  return request({
    url: '/v1/base_data/get_area',
    method: 'get',
    params
  })
}
/**
 *查看当前用户所属部门（事业部）
 */
export function getDepartment () {
  return request({
    url: '/v1/base_data/get_department',
    method: 'get'
  })
}
// 获取部门分析页面部门
export function getDepartmentAnalyse (data = {}) {
  return request({
    url: '/v1/look-permission/dept',
    method: 'post',
    data
  })
}

// 获取部门分析页面部门(xihu)
export function getXhDepartmentAnalyse (data = {}) {
  return request({
    url: '/v1/transaction_org/xihu/get_org',
    method: 'get',
    data
  })
}

/**
 *查看当前部门有权限的产品  department_code
 */
export function getDepartmentDrug (params) {
  return request({
    url: '/v1/base_data/get_department_drug',
    method: 'get',
    params
  })
}
/**
 *查看当前用户有权限的药品
 */
export function getUserDrug (params) {
  return request({
    url: '/v1/base_data/get_user_drug',
    method: 'get',
    params
  })
}

/**
 * 商业公司
 */
export function tradingCompanyGetCompany (data) {
  return request({
    url: '/v1/adb/trading_company/get_company',
    method: 'post',
    data
  })
}
/**
 * 商业公司
 */
export function tradingCompanyGetCompanyByUser (params) {
  return request({
    url: '/v1/trading_company/getCompanyByUser',
    method: 'get',
    params
  })
}

/**
 * 客户搜索接口
 */

// 根据clientId查询详情
export function scaClientDetail (id) {
  return request({
    url: '/v1/sca_client/detail/' + id,
    method: 'get'
  })
}

// 聚合查询订单
export function scaClientGroupSearch (data) {
  return request({
    url: '/v1/adb/sca_client/group/search',
    method: 'post',
    data
  })
}
// 商业覆盖分析聚合查询订单
export function scaClientGroupBussinessSearch (data) {
  return request({
    url: '/v1/sca_client/auth/search',
    method: 'post',
    data
  })
}

// 商业覆盖分析无权限聚合查询订单
export function analysisCoverage (data) {
  return request({
    url: '/v1/sca_client/analysis/coverage',
    method: 'post',
    data
  })
}
export function analysisCoverageNew (data) {
  return request({
    url: '/v1/tradingCompany/analysis/coverage',
    method: 'post',
    data
  })
}

// 根据clientId 设置经纬度不正确,以达到隐藏的作用
export function scaClientHidden (id) {
  return request({
    url: '/v1/sca_client/hidden/' + id,
    method: 'get'
  })
}

// 搜索订单信息与覆盖情况
export function scaClientSearch (data) {
  return request({
    url: '/v1/adb/sca_client/search',
    method: 'post',
    data
  })
}

// 搜索订单信息分页
export function scaClientSearchPage (data) {
  return request({
    url: '/v1/adb/sca_client/search/page',
    method: 'post',
    data
  })
}

// 数据库同步ElasticSearch数据
export function scaClientSyncEs () {
  return request({
    url: '/v1/sca_client/sync/es',
    method: 'post'
  })
}

/**
 * 用户所属地区管理api
 */
// 给用户添加所属地区
export function userAreaManageAdd (code, userIds, deleteBeforeAdd = false) {
  return request({
    url: '/v1/user/area/manage/add?deleteBeforeAdd=' + deleteBeforeAdd,
    method: 'post',
    data: { code, userIds }
  })
}

// 删除用户所属地区
export function userAreaManageDelete (code, userIds) {
  return request({
    url: '/v1/user/area/manage/delete',
    method: 'delete',
    params: { code, userIds }
  })
}

// 批量查询用户所属地区列表
export function userAreaBatchQuery (userIds, checkAndCompare = true) {
  return request({
    url: '/v1/user/area/manage/batch_query',
    method: 'get',
    params: { userIds, checkAndCompare }
  })
}

// 获取已选人员

// 添加已选人员

// 获取可选人员

// 删除已选人员

// 用户所属地区列表
export function userAreaManageQuery (params) {
  return request({
    url: '/v1/user/area/manage/query',
    method: 'get',
    params
  })
}

// 查询当前登录用户的可用地区列表
export function userAreaMeList () {
  return request({
    url: '/v1/user/area/me/list',
    method: 'get'
  })
}

// 用户所属地区列表
export function userAreaMeSubArea (params) {
  return request({
    url: 'v1/look-permission/areatree-ultimate',
    method: 'get',
    params
  })
}

/**
 * 用户相关
 */
// 新建用户
export function userManageCreate (data) {
  return request({
    url: '/v1/user/manage/create',
    method: 'post',
    data
  })
}

// 删除用户
export function userManageDelete (params) {
  return request({
    url: '/v1/user/manage/delete',
    method: 'delete',
    params
  })
}

// 修改用户基本信息
export function userManageModify (data) {
  return request({
    url: '/v1/user/manage/modify',
    method: 'post',
    data
  })
}

// 查询用户列表
export function userManageQuery (data) {
  return request({
    url: '/v1/user/manage/query',
    method: 'post',
    data
  })
}

// 当前工业可用的角色列表
export function userManageRole () {
  return request({
    url: '/v1/user/manage/role',
    method: 'get'
  })
}

// 用户信息
export function userMeInfo () {
  return request({
    url: '/v1/user/me/info',
    method: 'get'
  })
}
// 用户信息-个人文件导出
export function myexportFile (params) {
  return request({
    url: '/v1/myexport/list',
    method: 'get',
    params
  })
}
// 用户信息-个人文件删除
export function deleteExportFile (params) {
  return request({
    url: '/v1/myexport/delete',
    method: 'get',
    params
  })
}
// 修改当前用户自己的基本信息
export function userMeModify (data) {
  return request({
    url: '/v1/user/me/modify',
    method: 'post',
    data
  })
}

/**
 * 药厂信息管理
 */
// 地区人员管理
export function drugFactoryGetAreaSalesman (params) {
  return request({
    url: '/v1/drug_factory/get_area_salesman',
    method: 'get',
    params
  })
}

// 获取药品信息 无权限
export function drugFactoryGetDrug (params) {
  return request({
    url: '/v1/drug_factory/get_drug',
    method: 'get',
    params
  })
}

// 查询药品分类
export function drugFactoryGetDrugCategory (params) {
  return request({
    url: '/v1/drug_factory/get_drug_category',
    method: 'get',
    params
  })
}

// 获取药品规格
export function drugFactoryGetDrugSpec (params) {
  return request({
    url: '/v1/drug_factory/get_drug_spec',
    method: 'get',
    params
  })
}

// 查询工业药品
export function drugFactoryGetFactoryDrug (params) {
  return request({
    url: '/v1/drug_factory/get_factory_drug',
    method: 'get',
    params
  })
}

// 获取属于用户的药品信息
export function drugFactoryGetUserDrug (params) {
  return request({
    url: '/v1/drug_factory/get_user_drug',
    method: 'get',
    params
  })
}

// 获取属于用户的药品信息
export function drugFactoryGetUserDrugWithDefault (params) {
  return request({
    url: '/v1/drug_factory/get_user_drug_with_default',
    method: 'get',
    params
  })
}

// 搜索工业药品
export function drugFactorySearchFactoryDrug (params) {
  return request({
    url: '/v1/drug_factory/search_factory_drug',
    method: 'get',
    params
  })
}

/**
 * 行政区域
 */
// 获取区域
export function lbsAreaGetArea (params) {
  return request({
    url: '/v1/lbs_area/get_area',
    method: 'get',
    params
  })
}

// 获取子区域信息 params: code,level
export function lbsAreaGetChildArea (params) {
  return request({
    url: '/v1/lbs_area/get_child_area',
    method: 'get',
    params
  })
}

/**
 * 订单统计搜索
 */
// 活跃度搜索
export function scaClientOrderCoverageStatistics (params) {
  return request({
    url: '/v1/sca_client_order/coverage/statistics',
    method: 'get',
    params
  })
}

// 人均产出
export function scaClientOrderPerPersonPrice (params) {
  return request({
    url: '/v1/sca_client_order/per/person/price',
    method: 'get',
    params
  })
}

// 人均产出导出
export function exportPerAllOutput (data) {
  return request({
    url: 'v1/sca_client_order/per/person/price/export',
    method: 'post',
    data
  })
}
export function getOrg (params) {
  return request({
    url: '/v1/transaction_org/get_org',
    method: 'get',
    params
  })
}

// 单店产出
export function scaClientOrderPerShopPrice (params) {
  return request({
    url: '/v1/sca_client_order/per/shop/price',
    method: 'get',
    params
  })
}

// 统计接口
export function scaClientOrderStatistics (data) {
  return request({
    // baseURL: 'http://mock.bjzrdx.yiyao.cc/mock/5da83a89bfe4fa001d3997ce',
    url: '/v1/area-cover/detail/page',
    method: 'post',
    data
  })
}

// 统计接口
export function scaJmylClientOrderStatistics (data) {
  return request({
    // baseURL: 'http://mock.bjzrdx.yiyao.cc/mock/5da83a89bfe4fa001d3997ce',
    url: '/v1/area-cover/jmyl/detail/page',
    method: 'post',
    data
  })
}

// 统计接口
export function scaClientOrderStatisticsCenter (data) {
  return request({
    // baseURL: 'http://mock.bjzrdx.yiyao.cc/mock/5da83a89bfe4fa001d3997ce',
    url: '/v1/area-cover/kylin/detail/page',
    method: 'post',
    data
  })
}

// 商业公司统计接口
export function scaClientOrderTradingCompanyStatistics (data) {
  return request({
    url: '/v1/tradingCompany/statistics',
    method: 'post',
    data
  })
}

/**
 * 账号和登录
 */
// 退出登录
export function accountLoginLogout () {
  return request({
    url: '/v1/account/login/logout',
    method: 'post'
  })
}

// 刷新Token
export function accountLoginRefresh (params) {
  return request({
    url: '/v1/account/login/refresh/' + params.refresh_token,
    method: 'get'
  })
}

// 用户名+密码登录
export function accountLoginUsername (data) {
  return request({
    url: '/v1/account/login/username',
    method: 'post',
    data
  })
}

// 密码重置
export function accountManagePasswordReset (data) {
  return request({
    url: '/v1/account/manage/password/reset',
    method: 'post',
    data
  })
}

// 修改密码
export function accountPasswordModify (data) {
  return request({
    url: '/v1/account/password/modify',
    method: 'post',
    data
  })
}

// 密码重置
export function accountPasswordReset (data) {
  return request({
    url: '/v1/account/password/reset',
    method: 'post',
    data
  })
}

// 发送验证码
export function accountSendSms (data) {
  return request({
    url: '/v1/account/send_sms',
    method: 'post',
    data
  })
}

// 用户激活
export function accountUserActivate (data) {
  return request({
    url: '/v1/account/user/activate',
    method: 'post',
    data
  })
}

// 查询工厂下所有事业部
export function asyncGetAllOrg (factoryId = 1) {
  return request({
    url: '/v1/transaction_org/get_factory_org',
    method: 'get',
    params: { factoryId }
  })
}

// 查询当前用户所属部门事业部
export function asyncUserOrgAuth () {
  return request({
    url: '/v1/transaction_org/get_org',
    method: 'get'
  })
}

// 根据事业部查询所有业务人员层级列表
export function asyncGetSalesList (org) {
  return request({
    url: '/v1/sca_post_person/get_all_person',
    method: 'get',
    params: { org }
  })
}

// 添加人员
export function addPerson (data) {
  return request({
    url: '/v1/person/add',
    method: 'post',
    data
  })
}

// 修改人员
export function editPerson (data) {
  return request({
    url: '/v1/person/edit',
    method: 'post',
    data
  })
}

// 删除人员
export function deletePerson (data) {
  return request({
    url: '/v1/person/delete',
    method: 'post',
    data
  })
}

// 流向报告
export function transactionProcessReport (data) {
  return request({
    url: '/v1/sca_report/overview/transaction_process',
    method: 'get',
    params: data
  })
}
let baseURL = ''
if (process.env.NODE_ENV === 'development') {
  baseURL = '/appeal'
} else if (process.env.NODE_ENV === 'sit') {
  baseURL = '/appeal'
} else if (process.env.NODE_ENV === 'production') {
  baseURL = '/appeal'
}
// 流向接口
// 流向明细列表
export function channelDetailList (data) {
  // data.tenantId = '2'
  return request({
    url: '/v1/channel/sca/detail/list',
    method: 'post',
    data
  })
}

// 流向汇总列表详情
export function channelStatisticsDetail (data) {
  return request({
    baseURL,
    url: '/v1/channel/statistics/detail',
    method: 'post',
    data
  })
}

export function channelStatisticsList (data) {
  // data.tenantId = '2'
  return request({
    baseURL,
    url: '/v1/channel/sca/statistics/list',
    method: 'post',
    data
  })
}

// 申诉
// 申诉列表
export function appeals (data) {
  return request({
    baseURL,
    url: '/v1/appeals/sca',
    method: 'post',
    data
  })
}

// 新增申诉
export function addAppeals (data) {
  return request({
    baseURL,
    url: '/v1/appeals',
    method: 'put',
    data
  })
}

// 申诉详情
export function appealsDetails (id) {
  return request({
    baseURL,
    url: '/v1/appeals/' + id,
    method: 'get'
  })
}

// 删除申诉
export function deleteAppeals (id) {
  return request({
    baseURL,
    url: '/v1/appeals/' + id,
    method: 'delete'
  })
}

// 修改申诉
export function modifyAppeals (id, data) {
  return request({
    baseURL,
    url: '/v1/appeals/' + id,
    method: 'patch',
    data
  })
}

// 通过申诉
export function approveAppeals (id, data) {
  return request({
    baseURL,
    url: '/v1/appeals/approve/' + id,
    method: 'post',
    data
  })
}

// 申诉流向分页
export function channelList (data) {
  return request({
    baseURL,
    url: '/v1/appeals/channel-list',
    method: 'post',
    data
  })
}

// 申诉流向全量
export function channelDataList (data) {
  return request({
    baseURL,
    url: '/v1/appeals/channel-data-list',
    method: 'post',
    data
  })
}

// 拒绝申诉
export function rejectAppeals (id, data) {
  return request({
    baseURL,
    url: '/v1/appeals/reject/' + id,
    method: 'post',
    data
  })
}

// 处理完成之后的提交申诉
export function resolveAppeals (id, data) {
  return request({
    baseURL,
    url: '/v1/appeals/resolve/' + id,
    method: 'post',
    data
  })
}

// 新增申诉并提交
export function saveAndSubmit (data) {
  return request({
    baseURL,
    url: '/v1/appeals/save-and-submit',
    method: 'put',
    data
  })
}

// 提交申诉
export function submitAppeals (id) {
  return request({
    baseURL,
    url: '/v1/appeals/submit/' + id,
    method: 'post'
  })
}

// 修改并提交
export function updateAndSubmit (id, data) {
  return request({
    baseURL,
    url: '/v1/appeals/update-and-submit/' + id,
    method: 'patch',
    data
  })
}

/**
 * 生成七牛上传Token
 */
export function generateQiniuToken () {
  return request({
    baseURL,
    url: '/v1/qiniu/token',
    method: 'get'
  })
}

// 获取经销商
export function suppliersList (data) {
  return request({
    baseURL,
    url: '/v1/search/suppliers/list',
    method: 'post',
    data
  })
}

// 获取客户
export function clientList (data) {
  return request({
    baseURL,
    url: '/v1/search/sca/client/list',
    method: 'post',
    data
  })
}

// 获取产品
export function drugList (data) {
  return request({
    baseURL,
    url: '/v1/search/drug/list',
    method: 'post',
    data
  })
}

// 获取规格
export function specList (data) {
  return request({
    baseURL,
    url: '/v1/search/spec/list',
    method: 'post',
    data
  })
}
// 获取品牌产品
export function permissionDrugList (data) {
  return request({
    url: '/v1/look-permission/drug',
    method: 'post',
    data
  })
}
// 无权限产品列表
export function productDrugList (params) {
  return request({
    url: '/v1/product/search/productList',
    method: 'get',
    params
  })
}

// 获取产品品牌
export function brandList (data) {
  return request({
    baseURL,
    url: '/v1/search/brand/list',
    method: 'post',
    data
  })
}

export function getAllData () {
  return request({
    baseURL,
    url: '/v1/channel/get/standard_specAndName/list',
    method: 'get'
  })
}

// 获取标准产品名称
export function standardproductName (data) {
  return request({
    baseURL,
    url: '/v1/channel/get/standard/list',
    method: 'post',
    data
  })
}

// 获取标准产品规格
export function productSpecifications (data) {
  return request({
    baseURL,
    url: '/v1/channel/get/standard_specName/list',
    method: 'post',
    data
  })
}

export function exportDetailList (data) { // 导出流向明细列表
  return request({
    url: '/v1/channel/export/sca/detail/list',
    method: 'post',
    data
  })
}
export function getClientType (params) { // 导出流向明细列表
  return request({
    url: '/v1/client-type/list',
    method: 'get',
    params
  })
}
/**
 * 销售报表查询
 */
export function getPermissionProvince (params) {
  return request({
    url: '/v1/jointown/report/permission/province',
    method: 'get',
    params
  })
}
/**
 * 归属、属性、标签联动
 */
export function getThreeCascade (data) {
  return request({
    url: '/v1/tags/three-cascade-config',
    method: 'post',
    data
  })
}
/**
 * 归属、属性、标签联动
 */
export function areaGetCode (params) {
  return request({
    url: '/v1/lbs_area/get_areaCode',
    method: 'get',
    params
  })
}
// 消息接口
export function productMessageList () {
  return request({
    url: '/v1/sca-message/earliest-one',
    method: 'get'
  })
}
// 点击去查看
export function goSeeMessage () {
  return request({
    url: '/v1/sca-message/read-success-message',
    method: 'get'
  })
}

// 已读接口
export function producRreadMessage (id) {
  return request({
    url: '/v1/sca-message/read-message/' + id,
    method: 'post'
  })
}

// // // 获取租户下流向明细动态的表头部分
// export function getTableTitle () {
//   return request({
//     url: '/v1/tags/flow-detail-tag-info',
//     method: 'get'
//   })
// }
// // 获取租户下流向明细动态的表头部分
export function getTableTitle (params) {
  return request({
    url: '/v1/front/listTitle/' + params.resourceId,
    method: 'get'
    // params
  })
}

// 一次性返回省市接口
export function permissionAreaTree (params) {
  return request({
    url: '/v1/look-permission/areatree',
    method: 'get',
    params
  })
}

// // 获取租户下无权限地区部分
export function noPermissionAreaTree () {
  return request({
    url: '/v1/look-permission/areatree-ultimate',
    method: 'get'
  })
}

// 一次性返回省市接口（健民）
export function permissionAreaTreeNew (data) {
  return request({
    // baseURL: 'http://mock.bjzrdx.yiyao.cc/mock/5da83a89bfe4fa001d3997ce',
    url: '/v1/battle/map/dept/areatree',
    method: 'post',
    data
  })
}
// 获取用户信息新接口
export function getUserNew () {
  return request({
    url: '/v1/user/getPersonalDetailInfo',
    method: 'get'
  })
}

// 获取全量终端类型
export function getClientTypeList (params) {
  return request({
    url: '/v1/client-type/allList',
    method: 'get',
    params
  })
}
//  确认人接口
// /v1/appeals / getAppealsConfirmer
// 获取全量终端类型
export function getAppealsConfirmer (params) {
  return request({
    baseURL,
    url: '/v1/appeals/getAppealsConfirmer',
    method: 'get',
    params
  })
}
// 获取租户自定义动态标签
export function getResourceTagConfigDO (params) {
  return request({
    url: '/v1/tags/resource/' + params.resourceId + '/' + params.configType,
    method: 'get'
  })
}

// https://www.tapd.cn/61381256/markdown_wikis/show/#1161381256001001953   时间相关wiki有调整时请及时更新wiki
export function getFlowTime (dataType, flowType) {
  return request({
    url: '/v1/flow-time',
    method: 'post',
    data: {
      dataType,
      flowType
    }
  })
}

// 获取申诉可申诉清洗月份
export function getAppealsCleanFlowTime () {
  return request({
    url: '/v1/sca_client_order/clean-time/region-appeal',
    method: 'get'
  })
}

// https://www.tapd.cn/61381256/markdown_wikis/show/#1161381256001001953   时间相关wiki有调整时请及时更新wiki
// 大屏相关时间 概览、渠道看板
export function getDayReportTime () {
  return getFlowTime('dayReport', 'S')
}

// https://www.tapd.cn/61381256/markdown_wikis/show/#1161381256001001953   时间相关wiki有调整时请及时更新wiki
// 报表相关时间 月度数据的时间
export function getMonthTime () {
  return getFlowTime('month', 'S')
}

// https://www.tapd.cn/61381256/markdown_wikis/show/#1161381256001001953   时间相关wiki有调整时请及时更新wiki
// 最新流向的时间
export function getAllTime () {
  return getFlowTime('all', 'S')
}

// https://www.tapd.cn/61381256/markdown_wikis/show/#1161381256001001953   时间相关wiki有调整时请及时更新wiki
// ddi流向时间
export function getDdiTime (flowType) {
  return getFlowTime('ddi', flowType)
}

/**
 * 公共接口模板，当不确定接口地址、请求方式以及参数时可使用该模板
 * @param APIConfig 请求配置
 */
export function getAxiosTemplate (APIConfig) {
  const { url, data, method } = APIConfig
  const paramsAttr = method.toLowerCase() === 'post' ? 'data' : 'params'
  return request({
    url: url,
    method: method,
    [paramsAttr]: data
  })
}

// 获取无权限省份

export function frontAllProvince () {
  return request({
    url: '/v1/area-dimension-front/allProvince',
    method: 'get'
  })
}

export function frontAllPermissioProvince () {
  return request({
    url: '/v1/area-dimension-front/allProvince-permission',
    method: 'get'
  })
}

export function getAbnormalList () {
  return request({
    url: '/v1/abnormal/drop-down-list',
    method: 'get'
  })
}

// 获取有权限省份

export function frontPermissionProvince () {
  return request({
    url: '/v1/area-dimension-front/allProvince-permission-name',
    method: 'get'
  })
}

// 获取无权限产品tree 产品线

export function getProductDimension (params) {
  return request({
    url: '/v1/product-dimension-front/line2name2spec',
    method: 'get',
    params
  })
}
// 获取无权限产品tree 产品
export function getProductDimensionAll (params) {
  return request({
    url: '/v1/product-dimension-front/brandProductSpecTree/permission',
    method: 'get',
    params
  })
}

export function getQueryList (resourceId) {
  return request({
    url: '/v1/front/' + resourceId,
    method: 'get'
  })
}

/**
 * 获取指标
 *
 * @param {Array} queryCodes
 * @param {Object} params
 * @param {Object} specialParam
 * @param {Object|String} transFlag
 * @returns {AxiosPromise}
 */
export function fetchIndicatorData (queryCodes, params, specialParam = {}, transFlag = false) {
  const data = {
    params,
    ...specialParam
  }
  if (transFlag) {
    data['transFlag'] = transFlag
  }
  return request({
    url: `/v1/front/page/indicator-data?variableCodes=${join(queryCodes)}`,
    method: 'post',
    data
  })
}

export function exportIndicatorData (fileName, moduleName, keyword, items, indicatorCode, params) {
  const data = {
    fileName: fileName,
    moduleName: moduleName,
    keyword: keyword,
    items: items,
    dataSource: {
      type: 'Indicator',
      indicator: indicatorCode,
      params: params
    }
  }
  return request({
    url: `/v1/general/report/export`,
    method: 'post',
    data
  })
}

export function exportMatrixData (moduleName, keyword, rows, columns, values, totals) {
  const time = new Date()
  let dataList = []
  if (values !== null) {
    dataList = dataList.concat(values)
  }
  if (totals !== null) {
    dataList = dataList.concat(totals)
  }
  const data = {
    fileName: moduleName + '_' + time.getFullYear() + (time.getMonth() + 1) + time.getDate() + time.getHours() + time.getMinutes() + time.getSeconds(),
    moduleName: moduleName,
    keyword: keyword,
    items: [],
    rows: rows,
    columns: columns,
    dataSource: {
      type: 'DataMatrix',
      dataMatrix: dataList
    }
  }
  return request({
    url: `/v1/general/report/export`,
    method: 'post',
    data
  })
}

export function exportWidgetData (moduleName, keyword, widgetId, params) {
  const time = new Date()
  const data = {
    fileName: moduleName + '_' + time.getFullYear() + (time.getMonth() + 1) + time.getDate() + time.getHours() + time.getMinutes() + time.getSeconds(),
    moduleName: moduleName,
    keyword: keyword,
    items: [],
    dataSource: {
      type: 'Widget',
      widgetId: widgetId,
      params: params
    }
  }
  return request({
    url: `/v1/general/report/export`,
    method: 'post',
    data
  })
}

export function getGeography (areaCode, version, type) {
  return request({
    url: '/v1/lbs_area/geography',
    method: 'get',
    params: {
      areaCode,
      version,
      type
    }
  })
}

/**
 * 修改表头列表
 * @param data
 * @param key
 */
export function setFiledList (data, key) {
  return request({
    url: '/v1/report-header-filter/set/' + key,
    method: 'post',
    data
  })
}

/**
 * 查询表头列表
 * @param params
 */
export function getFiledList (key) {
  return request({
    url: '/v1/report-header-filter/field-list/' + key,
    method: 'get'
  })
}

/**
 * 获取下拉
 * @param key
 */
export function tagDimensionFront (key) {
  return request({
    url: '/v1/tag-dimension-front/item-group/' + key,
    method: 'get'
  })
}

/**
 * 获取中昊负责人下拉
 * @param key
 */
export function getChargePerson () {
  return request({
    url: '/v1/tag-dimension-front/adb-table-column/PURE_SALES_DETAIL/charge_person',
    method: 'get'
  })
}

export function exportRetry (id) {
  return request({
    url: '/v1/myexport/retry',
    method: 'get',
    params: {
      id
    }
  })
}

export function biWidgetData (widgetId, data) {
  return request({
    // baseURL: 'https://mock.yiyao.cc/mock/5e55d990dcfa5c001de7b868/example_copy',
    url: '/v1/bi/data/widgetId/' + widgetId,
    method: 'post',
    data: data
  })
}
